module.exports = __webpack_public_path__ + "static/HandCreamTube-dfc25214d87cdd05dfbad61067d8967a.jpg";